import { ComponentClass } from 'react';
export { ComponentClass };
import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CalendarSharing", webpackPrefetch: true */ './lazyIndex')
);
export * from './actions/publicActions';

// export lazy public actions
export let lazyLoadAllCalendarPublishingPermissions = new LazyAction(
    lazyModule,
    m => m.loadAllCalendarPublishingPermissions
);
export let lazyInitializeCalendarPublishingPermissionStore = new LazyAction(
    lazyModule,
    m => m.initializeCalendarPublishingPermissionStore
);
export let lazyUpdatePublishSelectedCalendar = new LazyAction(
    lazyModule,
    m => m.updatePublishSelectedCalendar
);
export let lazySetCalendarPublishingErrorStateError = new LazyAction(
    lazyModule,
    m => m.setCalendarPublishingErrorStateError
);

export const lazyShowCalendarSharingPermissionsDialog = new LazyAction(
    lazyModule,
    m => m.showCalendarSharingPermissionsDialog
);
export const lazyHideCalendarSharingPermissionsDialog = new LazyAction(
    lazyModule,
    m => m.hideCalendarSharingPermissionsDialog
);

export { default as getPublishingStore } from './store/publishingStore';
export { default as CalendarPublishingError } from './store/schema/CalendarPublishingError';

export let CalendarSharingDialogComponent = createLazyComponent(
    lazyModule,
    m => m.CalendarSharingDialog
);

export let CalendarPublishingInviteComponent = createLazyComponent(
    lazyModule,
    m => m.CalendarPublishingInviteComponent
);

export let CalendarsPublishedComponent = createLazyComponent(
    lazyModule,
    m => m.CalendarsPublishedComponent
);

export let CalendarSharingPermissionsModalRenderer = createLazyComponent(
    lazyModule,
    m => m.CalendarSharingPermissionsModalRenderer
);
